import styled from 'styled-components';

const SkeletonContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: center;
`;

const SkeletonTitle = styled.div`
  width: 120px;
  height: 32px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 8px;
  margin: 0 auto 1rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const SkeletonDesc = styled.div`
  width: 100%;
  max-width: 600px;
  height: 20px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 4px;
  margin: 0 auto 3rem;
  direction: ${({ $isRTL }) => ($isRTL ? 'rtl' : 'ltr')};
  text-align: ${({ $isRTL }) => ($isRTL ? 'right' : 'left')};
`;

const SkeletonForm = styled.div`
  width: 100%;
  max-width: 600px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card_light} 25%,
    ${({ theme }) => theme.card} 50%,
    ${({ theme }) => theme.card_light} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 15px;
  padding: 2rem;
  margin: 0 auto 4rem;
`;

const SkeletonField = styled.div`
  width: 100%;
  height: 48px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card} 25%,
    ${({ theme }) => theme.card_light} 50%,
    ${({ theme }) => theme.card} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 8px;
  margin-bottom: 1.5rem;
`;

const SkeletonButton = styled.div`
  width: 120px;
  height: 48px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.card} 25%,
    ${({ theme }) => theme.card_light} 50%,
    ${({ theme }) => theme.card} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 3s infinite;
  border-radius: 8px;
  margin: 0 auto;
`;

const ContactSkeleton = ({ $isRTL = false }) => (
  <SkeletonContainer $isRTL={$isRTL}>
    <SkeletonTitle $isRTL={$isRTL} className="skeleton-enhanced" />
    <SkeletonDesc $isRTL={$isRTL} className="skeleton-enhanced" />
    <SkeletonForm>
      <SkeletonField className="skeleton-enhanced" />
      <SkeletonField className="skeleton-enhanced" />
      <SkeletonField className="skeleton-enhanced" />
      <SkeletonButton className="skeleton-enhanced-dark" />
    </SkeletonForm>
  </SkeletonContainer>
);

export default ContactSkeleton;
